
// M019 global header
function updateGlobalHeader(){

    if($(".globalHeaderTitle").length > 0){
        $(".globalHeaderTitle").each(function(){

            var bgHeight = $(this).height() + 60;

            var $globalHeader = $(this).closest(".globalHeader");
            if($globalHeader && $globalHeader.length > 0){
                var $bg = $globalHeader.children(".headerImageBackground")
                if($bg){
                    $bg.css("min-height", bgHeight + "px");
                }
            }

            /*
            if($(this).find(".infocopy").length > 0){
                $(this).find(".infocopy").each(function(){

                    var $inf = $(this);

                    if($inf.hasClass("hasDescription")){

                        var $dsc = $inf.children(".description");
                        
                        if($dsc.height() > 0 && $dsc.width() > 0){

                            var c = 0;
                            while($dsc.height() > $dsc.width()) {
                                if(($dsc.width()+10) < $inf.width()){
                                    $dsc.css("width", $dsc.width()+10);
                                }
                                c++;
                                //prevent endless while loop...
                                if(c >= 10){
                                    $dsc.css("width", $inf.width());
                                    break;
                                }
                            }
                        }

                    }
                });  
            }       
            */  

        });        
    }
}